angular
	.module('qbePortal.services')
	.constant('STATES', [
		{
			label: 'ACT',
			value: 'ACT'
		},
		{
			label: 'NSW',
			value: 'NSW'
		},
		{
			label: 'NT',
			value: 'NT'
		},
		{
			label: 'QLD',
			value: 'QLD'
		},
		{
			label: 'SA',
			value: 'SA'
		},
		{
			label: 'TAS',
			value: 'TAS'
		},
		{
			label: 'VIC',
			value: 'VIC'
		},
		{
			label: 'WA',
			value: 'WA'
		}
	])
	.constant('CAMPAIGN_COOKIE_EXPIRY', 30)
	.constant('CREDIT_CARD_ATTEMPT', 3)
	.service('Util', Util)
	.filter('excessValue', function() {
		return function(excessValue, baseExcess) {
			return excessValue + baseExcess;
		};
	})
	.service('labelService', ['$window', LabelService])
	.service('validationService', ['labelService', ValidationService])
	.service('storage', ['$window', '$state', SessionStorage])
	.service('userInputRepository', ['storage', 'Util', UserInputRepository])
	.service('hierarchyDecorator', HierarchyDecorator)
	.service('MAService', ['$http', 'campaignService', MAService])
	.service('quoteResultModelBuilder', ['Util', QuoteResultModelBuilder])
	.service('serviceResponseRepository', [
		'storage',
		ServiceResponseRepository
	])
	.service('quoteResultModelFactory', [
		'MODULE_INFO',
		QuoteResultModelFactory
	])
	.service('quoteServiceResponseTransformer', [
		'quoteResultModelBuilder',
		'serviceResponseRepository',
		'quoteResultModelFactory',
		QuoteServiceResponseTransformer
	])
	.service('jsonMapper', ['serviceResponseRepository', JsonMapper])
	.service('splitterRequestTransformer', [
		'Util',
		'serviceResponseRepository',
		'jsonMapper',
		'publicIDTransformer',
		'coverTypeTransformer',
		SplitterRequestTransformer
	])
	.service('quoteOptions', [
		'quoteConfiguration',
		'serviceResponseRepository',
		'quoteResultModelBuilder',
		'storage',
		QuoteOptions
	])
	.service('quoteRequestRepository', [
		'Util',
		'storage',
		'quoteOptions',
		'quoteConfiguration',
		'userInputRepository',
		'serviceResponseRepository',
		'structuredRequestTransformer',
		'defaultValueRequestTransformer',
		'formatConverterTransformer',
		'cleanRequestTransformer',
		'splitterRequestTransformer',
		'publicIDTransformer',
		'policyHolderHandler',
		'coverTypeTransformer',
		'coverTypeResolver',
		'coverOfferingResolver',
		'triggerGoalTransformer',
		QuoteRequestRepository
	])
	.service('portalServiceWrapper', [
		'guideWireService',
		'quoteRequestRepository',
		'serviceResponseRepository',
		'retrieveSavedQuoteResponseTransformer',
		'quoteServiceResponseTransformer',
		'quoteOptions',
		PortalServiceWrapper
	])
	.service('guideWireService', ['$http', 'storage', 'Util', GuideWireService])
	.service('regoSearchService', [
		'guideWireService',
		function(guideWireService) {
			return RegoSearchService.create(guideWireService);
		}
	])
	.service('gtmService', ['$window', 'campaignService', GtmService])
	.service('coverTypeResolver', ['MODULE_INFO', CoverTypeResolverService])
	.service('coverOfferingResolver', [
		'MODULE_INFO',
		CoverOfferingResolverService
	])
	.service('aggregatedRemoveService', ['storage', AggregatedRemoveService])
	.service('quoteResultFilter', QuoteResultFilter)
	.service('campaignService', [
		'ipCookie',
		'Util',
		'labelService',
		'CAMPAIGN_COOKIE_EXPIRY',
		CampaignService
	])
	.service('tokenTimeoutService', [
		'$state',
		'jwtHelper',
		'storage',
		'labelService',
		'MODULE_INFO',
		JWTTimeoutService
	]);

angular
	.module('qbePortal.services.bike')
	/** requires insurance form type */
	.constant('MODULE_INFO', {
		id: 'bike',
		insuranceType: 'Bike',
		routePrefix: 'bike.',
		startRouteName: 'bike.bike',
		productCode: 'QPMMotorBike',
		availableCoverTypes: [],
		mainFormName: 'bikeForm',
		paymentPageRouteName: 'bike.payment',
		donePageRouteName: 'bike.done',
		paymentPanelButtonText: {
			'bike.quote': 'purchase_now',
			'bike.contact': 'proceed_to_payment'
		}
	})
	.service('quoteConfiguration', BikeQuoteConfiguration)
	.service('retrieveSavedQuoteResponseTransformer', [
		'$filter',
		'jsonMapper',
		'Util',
		BikeRetrieveSavedQuoteResponseTransformer
	])
	.service('cleanRequestTransformer', [
		'Util',
		'jsonMapper',
		BikeCleanRequestTransformer
	])
	.service('formatConverterTransformer', [
		'Util',
		'jsonMapper',
		BikeFormatConverterTransformer
	])
	.service('defaultValueRequestTransformer', [
		'Util',
		'jsonMapper',
		BikeDefaultValueRequestTransformer
	])
	.service('structuredRequestTransformer', [
		'jsonMapper',
		'Util',
		'quoteOptions',
		'storage',
		BikeStructureRequestTransformer
	])
	.service('publicIDTransformer', [
		'Util',
		'jsonMapper',
		'serviceResponseRepository',
		'aggregatedRemoveService',
		BikePublicIDTransformer
	])
	.service('policyHolderHandler', [
		'Util',
		'publicIDTransformer',
		BikePolicyHolderHandler
	])
	.service('coverTypeTransformer', [
		'jsonMapper',
		'Util',
		BikeCoverTypeTransformer
	])
	.service('coverTypeResolver', ['MODULE_INFO', CoverTypeResolverService])
	.service('quoteModelFactory', [
		'MODULE_INFO',
		'userInputRepository',
		'serviceResponseRepository',
		'quoteOptions',
		'quoteRequestRepository',
		'Util',
		'$rootScope',
		QuoteModelFactory
	])
	.service('quoteResultModelFactory', [
		'MODULE_INFO',
		QuoteResultModelFactory
	])
	.service('paymentService', [
		'$http',
		'$state',
		'storage',
		'userInputRepository',
		'portalServiceWrapper',
		'quoteModelFactory',
		'Util',
		'quoteOptions',
		'paymentLoggerService',
		function(
			$http,
			$state,
			storage,
			userInputRepository,
			portalServiceWrapper,
			quoteModelFactory,
			util,
			quoteOptions,
			paymentLoggerService
		) {
			return PaymentService.bootstrap(
				$http,
				$state,
				storage,
				userInputRepository,
				portalServiceWrapper,
				quoteModelFactory,
				util,
				quoteOptions,
				paymentLoggerService
			);
		}
	])
	.service('triggerGoalTransformer', [
		'jsonMapper',
		'Util',
		BikeTriggerGoalTransformer
	]);

angular
	.module('qbePortal.services.caravan')
	/** requires insurance form type */
	.constant('MODULE_INFO', {
		id: 'caravan',
		insuranceType: 'Caravan',
		routePrefix: 'caravan.',
		startRouteName: 'caravan.caravan',
		productCode: 'QPCCaravanTrailer',
		mainFormName: 'caravanForm',
		paymentPageRouteName: 'caravan.payment',
		donePageRouteName: 'caravan.done',
		paymentPanelButtonText: {
			'caravan.quote': 'purchase_now',
			'caravan.contact': 'proceed_to_payment'
		}
	})
	.service('quoteConfiguration', CaravanQuoteConfiguration)
	.service('retrieveSavedQuoteResponseTransformer', [
		'$filter',
		'jsonMapper',
		'Util',
		CaravanRetrieveSavedQuoteResponseTransformer
	])
	.service('cleanRequestTransformer', [
		'Util',
		'jsonMapper',
		CaravanCleanRequestTransformer
	])
	.service('formatConverterTransformer', [
		'Util',
		'jsonMapper',
		CaravanFormatConverterTransformer
	])
	.service('defaultValueRequestTransformer', [
		'Util',
		'jsonMapper',
		'userInputRepository',
		'quoteOptions',
		CaravanDefaultValueRequestTransformer
	])
	.service('structuredRequestTransformer', [
		'jsonMapper',
		'Util',
		'quoteOptions',
		'storage',
		CaravanStructureRequestTransformer
	])
	.service('publicIDTransformer', [
		'Util',
		'jsonMapper',
		'serviceResponseRepository',
		'aggregatedRemoveService',
		CaravanPublicIDTransformer
	])
	.service('policyHolderHandler', [
		'Util',
		'publicIDTransformer',
		CaravanPolicyHolderHandler
	])
	.service('coverTypeTransformer', [
		'Util',
		'jsonMapper',
		CaravanCoverTypeTransformer
	])
	.service('coverTypeResolver', ['MODULE_INFO', CoverTypeResolverService])
	.service('quoteModelFactory', [
		'MODULE_INFO',
		'userInputRepository',
		'serviceResponseRepository',
		'quoteOptions',
		'quoteRequestRepository',
		'Util',
		'$rootScope',
		QuoteModelFactory
	])
	.service('paymentService', [
		'$http',
		'$state',
		'storage',
		'userInputRepository',
		'portalServiceWrapper',
		'quoteModelFactory',
		'Util',
		'quoteOptions',
		'paymentLoggerService',
		function(
			$http,
			$state,
			storage,
			userInputRepository,
			portalServiceWrapper,
			quoteModelFactory,
			Util,
			quoteOptions,
			paymentLoggerService
		) {
			return PaymentService.bootstrap(
				$http,
				$state,
				storage,
				userInputRepository,
				portalServiceWrapper,
				quoteModelFactory,
				Util,
				quoteOptions,
				paymentLoggerService
			);
		}
	])
	.filter('vehicleType', function() {
		return function(type) {
			var vehicleTypes = {
				caravan: 'Caravan',
				campertrailer: 'Camper Trailer',
				slideoncamper: 'Slide on Camper',
				goodscarryingtrailer: 'Goods Carrying Trailer',
				campervan: 'Camper Van',
				relocatablehome: 'Relocatable Home',
				motorhome: 'Motor Home'
			};

			return vehicleTypes[type];
		};
	})
	.service('triggerGoalTransformer', [
		'jsonMapper',
		'Util',
		CaravanTriggerGoalTransformer
	]);

angular
	.module('qbePortal.services.home')
	/** requires insurance form type */
	.constant('MODULE_INFO', {
		id: 'home',
		insuranceType: 'Home',
		routePrefix: 'home.',
		startRouteName: 'home.estimate',
		productCode: 'QPHHome',
		availableCoverTypes: [],
		mainFormName: 'homeForm',
		paymentPageRouteName: 'home.payment',
		donePageRouteName: 'home.done',
		paymentPanelButtonText: {
			'home.quote': 'purchase_now',
			'home.contact': 'proceed_to_payment'
		}
	})
	// service('commonData', 'storage', HomeCommonData ).
	.service('quoteConfiguration', HomeQuoteConfiguration)
	.service('retrieveSavedQuoteResponseTransformer', [
		'$filter',
		'jsonMapper',
		'Util',
		HomeRetrieveSavedQuoteResponseTransformer
	])
	.service('splitterRequestTransformer', [
		'Util',
		'serviceResponseRepository',
		'jsonMapper',
		'publicIDTransformer',
		'coverTypeTransformer',
		HomeSplitterRequestTransformer
	])
	.service('cleanRequestTransformer', [
		'Util',
		'jsonMapper',
		HomeCleanRequestTransformer
	])
	.service('formatConverterTransformer', [
		'Util',
		'jsonMapper',
		HomeFormatConverterTransformer
	])
	.service('defaultValueRequestTransformer', [
		'Util',
		'jsonMapper',
		'userInputRepository',
		'quoteOptions',
		HomeDefaultValueRequestTransformer
	])
	.service('structuredRequestTransformer', [
		'jsonMapper',
		'Util',
		'quoteOptions',
		'storage',
		HomeStructureRequestTransformer
	])
	.service('publicIDTransformer', [
		'Util',
		'jsonMapper',
		'serviceResponseRepository',
		HomePublicIDTransformer
	])
	.service('policyHolderHandler', [
		'Util',
		'publicIDTransformer',
		HomePolicyHolderHandler
	])
	.service('coverTypeTransformer', [
		'Util',
		'jsonMapper',
		HomeCoverTypeTransformer
	])
	.service('coverTypeResolver', ['MODULE_INFO', CoverTypeResolverService])
	.service('quoteModelFactory', [
		'MODULE_INFO',
		'userInputRepository',
		'serviceResponseRepository',
		'quoteOptions',
		'quoteRequestRepository',
		'Util',
		'$rootScope',
		QuoteModelFactory
	])
	.service('quoteResultModelFactory', [
		'MODULE_INFO',
		QuoteResultModelFactory
	])
	.service('paymentService', [
		'$http',
		'$state',
		'storage',
		'userInputRepository',
		'portalServiceWrapper',
		'quoteModelFactory',
		'Util',
		'quoteOptions',
		'paymentLoggerService',
		function(
			$http,
			$state,
			storage,
			userInputRepository,
			portalServiceWrapper,
			quoteModelFactory,
			Util,
			quoteOptions,
			paymentLoggerService
		) {
			return PaymentService.bootstrap(
				$http,
				$state,
				storage,
				userInputRepository,
				portalServiceWrapper,
				quoteModelFactory,
				Util,
				quoteOptions,
				paymentLoggerService
			);
		}
	])
	.service('triggerGoalTransformer', [
		'jsonMapper',
		'Util',
		BikeTriggerGoalTransformer
	]);;

angular
	.module('qbePortal.services.vehicle')
	/** requires insurance form type */
	.constant('MODULE_INFO', {
		id: 'vehicle',
		insuranceType: 'Car',
		routePrefix: 'vehicle.',
		startRouteName: 'vehicle.vehicle',
		productCode: 'QPMMotorVehicle',
		availableCoverTypes: [],
		mainFormName: 'vehicleForm',
		paymentPageRouteName: 'vehicle.payment',
		donePageRouteName: 'vehicle.done',
		paymentPanelButtonText: {
			'vehicle.quote': 'purchase_now',
			'vehicle.contact': 'proceed_to_payment'
		}
	})
	// service('commonData', [ 'storage', VehicleCommonData])
	.service('quoteConfiguration', VehicleQuoteConfiguration)
	.service('retrieveSavedQuoteResponseTransformer', [
		'$filter',
		'jsonMapper',
		'Util',
		VehicleRetrieveSavedQuoteResponseTransformer
	])
	.service('cleanRequestTransformer', [
		'Util',
		'jsonMapper',
		VehicleCleanRequestTransformer
	])
	.service('formatConverterTransformer', [
		'Util',
		'jsonMapper',
		VehicleFormatConverterTransformer
	])
	.service('defaultValueRequestTransformer', [
		'Util',
		'jsonMapper',
		'userInputRepository',
		'quoteOptions',
		VehicleDefaultValueRequestTransformer
	])
	.service('structuredRequestTransformer', [
		'jsonMapper',
		'Util',
		'quoteOptions',
		'storage',
		VehicleStructureRequestTransformer
	])
	.service('publicIDTransformer', [
		'Util',
		'jsonMapper',
		'serviceResponseRepository',
		'aggregatedRemoveService',
		VehiclePublicIDTransformer
	])
	.service('policyHolderHandler', [
		'Util',
		'publicIDTransformer',
		VehiclePolicyHolderHandler
	])
	.service('coverTypeTransformer', [
		'Util',
		'jsonMapper',
		VehicleCoverTypeTransformer
	])
	.service('coverTypeResolver', ['MODULE_INFO', CoverTypeResolverService])
	.service('quoteModelFactory', [
		'MODULE_INFO',
		'userInputRepository',
		'serviceResponseRepository',
		'quoteOptions',
		'quoteRequestRepository',
		'Util',
		'$rootScope',
		QuoteModelFactory
	])
	.service('paymentService', [
		'$http',
		'$state',
		'storage',
		'userInputRepository',
		'portalServiceWrapper',
		'quoteModelFactory',
		'Util',
		'quoteOptions',
		'paymentLoggerService',
		function(
			$http,
			$state,
			storage,
			userInputRepository,
			portalServiceWrapper,
			quoteModelFactory,
			Util,
			quoteOptions,
			paymentLoggerService
		) {
			return PaymentService.bootstrap(
				$http,
				$state,
				storage,
				userInputRepository,
				portalServiceWrapper,
				quoteModelFactory,
				Util,
				quoteOptions,
				paymentLoggerService
			);
		}
	]);

angular
	.module('qbePortal.services.ctp')
	/** requires insurance form type */
	.constant('MODULE_INFO', {
		id: 'ctp',
		insuranceType: 'CTP SA',
		routePrefix: 'ctp.',
		startRouteName: 'ctp.ctp',
		productCode: '',
		availableCoverTypes: [],
		mainFormName: 'ctpForm',
		paymentPageRouteName: '',
		donePageRouteName: '',
		paymentPanelButtonText: {}
	})
	.service('quoteConfiguration', GenericConfiguration)
	.service('retrieveSavedQuoteResponseTransformer', [
		'$filter',
		'jsonMapper',
		'Util',
		GenericConfiguration
	])
	.service('cleanRequestTransformer', [
		'Util',
		'jsonMapper',
		GenericConfiguration
	])
	.service('formatConverterTransformer', [
		'Util',
		'jsonMapper',
		GenericConfiguration
	])
	.service('defaultValueRequestTransformer', [
		'Util',
		'jsonMapper',
		GenericConfiguration
	])
	.service('structuredRequestTransformer', [
		'jsonMapper',
		'Util',
		'quoteOptions',
		GenericConfiguration
	])
	.service('publicIDTransformer', [
		'Util',
		'jsonMapper',
		'serviceResponseRepository',
		'aggregatedRemoveService',
		GenericConfiguration
	])
	.service('policyHolderHandler', [
		'Util',
		'publicIDTransformer',
		GenericConfiguration
	])
	.service('coverTypeTransformer', [
		'Util',
		'jsonMapper',
		GenericConfiguration
	])
	.service('coverTypeResolver', ['MODULE_INFO', GenericConfiguration])
	.service('quoteModelFactory', [
		'MODULE_INFO',
		'userInputRepository',
		'serviceResponseRepository',
		'quoteOptions',
		'quoteRequestRepository',
		'Util',
		'$rootScope',
		QuoteModelFactory
	])
	.service('paymentService', [
		'$http',
		'$state',
		'storage',
		'userInputRepository',
		'portalServiceWrapper',
		'quoteModelFactory',
		'Util',
		'quoteOptions',
		function(
			$http,
			$state,
			storage,
			userInputRepository,
			portalServiceWrapper,
			quoteModelFactory,
			Util,
			quoteOptions
		) {
			return PaymentService.bootstrap(
				$http,
				$state,
				storage,
				userInputRepository,
				portalServiceWrapper,
				quoteModelFactory,
				Util,
				quoteOptions
			);
		}
	])
	.service('triggerGoalTransformer', [
		'jsonMapper',
		'Util',
		BikeTriggerGoalTransformer
	]);;

angular
	.module('qbePortal.services.payments')
	.constant('MODULE_INFO', {
		/*id is for QBE bar on top and side bar on left*/
		id: 'payments',
		insuranceType: 'Car',
		routePrefix: 'payments.',
		startRouteName: 'payments.payments',
		productCode: 'QPMMotorVehicle',
		availableCoverTypes: [],
		mainFormName: 'paybillForm',
		paymentPageRouteName: 'payments.payments',
		donePageRouteName: 'payments.complete',
		paymentPanelButtonText: {
			'payments.quote': 'purchase_now',
			'payments.contact': 'proceed_to_payment'
		}
	})
	.service('quoteConfiguration', GenericConfiguration)
	.service('retrieveSavedQuoteResponseTransformer', [
		'$filter',
		'jsonMapper',
		'Util',
		GenericConfiguration
	])
	.service('cleanRequestTransformer', [
		'Util',
		'jsonMapper',
		GenericConfiguration
	])
	.service('formatConverterTransformer', [
		'Util',
		'jsonMapper',
		GenericConfiguration
	])
	.service('defaultValueRequestTransformer', [
		'Util',
		'jsonMapper',
		GenericConfiguration
	])
	.service('structuredRequestTransformer', [
		'jsonMapper',
		'Util',
		'quoteOptions',
		GenericConfiguration
	])
	.service('publicIDTransformer', [
		'Util',
		'jsonMapper',
		'serviceResponseRepository',
		'aggregatedRemoveService',
		GenericConfiguration
	])
	.service('policyHolderHandler', [
		'Util',
		'publicIDTransformer',
		GenericConfiguration
	])
	.service('coverTypeTransformer', [
		'Util',
		'jsonMapper',
		GenericConfiguration
	])
	.service('coverTypeResolver', ['MODULE_INFO', GenericConfiguration])
	.service('quoteModelFactory', [
		'MODULE_INFO',
		'userInputRepository',
		'serviceResponseRepository',
		'quoteOptions',
		'quoteRequestRepository',
		'Util',
		'$rootScope',
		QuoteModelFactory
	])
	.service('paymentService', [
		'$http',
		'$state',
		'storage',
		'userInputRepository',
		'portalServiceWrapper',
		'quoteModelFactory',
		'Util',
		'quoteOptions',
		'paymentLoggerService',
		function(
			$http,
			$state,
			storage,
			userInputRepository,
			portalServiceWrapper,
			quoteModelFactory,
			Util,
			quoteOptions,
			paymentLoggerService
		) {
			return PaymentService.bootstrap(
				$http,
				$state,
				storage,
				userInputRepository,
				portalServiceWrapper,
				quoteModelFactory,
				Util,
				quoteOptions,
				paymentLoggerService
			);
		}
	])
	.service('triggerGoalTransformer', [
		'jsonMapper',
		'Util',
		BikeTriggerGoalTransformer
	]);;
